import { Breadcrumb, Button, Card, Empty, Form, Icon, message, Modal, Table, Upload } from 'antd';
import { UploadFile } from 'antd/lib/upload/interface';
import gql from 'graphql-tag';
import React, { Component } from 'react';
import { Mutation, Query } from 'react-apollo';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Panel } from 'src/components/Panel';
import * as xlsx from 'xlsx';

import { Course } from '../enrollment/Enrollment';
import { SpeechAddition } from './AddSpeech';

const SpeechAdditionForm: any = Form.create({})(SpeechAddition);

const COURSE_LIST_QUERY = gql`
  query courseList($ids: [ID]) {
    courses(ids: $ids) {
      id
      name
      description
      createdAt
      lessons {
        id
        name
      }
    }
  }
`;

const UPLOAD_FILE = gql`
  mutation batchImportSpeech($speechJSON: String, $courseId: ID) {
    batchImportSpeech(speechJSON: $speechJSON, courseId: $courseId) {
      id
    }
  }
`;

interface State {
  speechJSON?: string;
  isShowBatchImportModal: boolean;
  fileList?: UploadFile[];
}

interface Props {
  courseId: string;
}

type AllProps = RouteComponentProps<Props>;

export class LessonList extends Component<AllProps, State> {
  constructor(props: AllProps) {
    super(props);
    this.state = {
      isShowBatchImportModal: false,
    };
  }

  showSpeechImportModal = () => {
    this.setState({ isShowBatchImportModal: true });
  };

  hideSpeechImportModal = () => {
    this.setState({ isShowBatchImportModal: false, fileList: [], speechJSON: '' });
  };

  batchImportSpeeches = () => {
    const { speechJSON } = this.state;
    const courseId = Number(this.props.match.params.courseId);
    const props = {
      beforeUpload: (file: UploadFile | Blob) => {
        const oneFile = file as UploadFile;
        if (oneFile.status !== 'removed') {
          const fileList = [oneFile];
          this.setState({ fileList });
          const reader = new FileReader();
          const blob = file as Blob;
          reader.readAsBinaryString(blob);
          reader.onload = (event: any) => {
            const data = event.target.result;
            const workbook = xlsx.read(data, {
              type: 'binary',
            });
            workbook.SheetNames.forEach(sheetName => {
              const speechJSON = JSON.stringify(xlsx.utils.sheet_to_json(workbook.Sheets[sheetName]));
              this.setState({ speechJSON });
            });
          };
        }
        return false;
      },
      onRemove: () => {
        this.setState({ fileList: [], speechJSON: '' });
      },
    };
    return (
      <Mutation mutation={UPLOAD_FILE} variables={{ speechJSON, courseId }}>
        {uploadSpeeches => {
          return (
            <>
              <Button type="primary" onClick={this.showSpeechImportModal} style={{ float: 'right' }}>
                批量添加
              </Button>
              <Modal
                title="添加话术"
                visible={this.state.isShowBatchImportModal}
                onOk={async () => {
                  try {
                    await uploadSpeeches();
                    message.success('添加成功！');
                    this.setState({ isShowBatchImportModal: false, fileList: [], speechJSON: '' });
                  } catch (error) {
                    const [err] = error.graphQLErrors;
                    message.error(err.message);
                  }
                }}
                onCancel={this.hideSpeechImportModal}
              >
                <div>
                  <Upload {...props} accept=".xls, .xlsx" fileList={this.state.fileList} multiple={false}>
                    <Button>
                      <Icon type="upload" /> 选择文件
                    </Button>
                  </Upload>
                </div>
              </Modal>
            </>
          );
        }}
      </Mutation>
    );
  };

  render() {
    const courseId = Number(this.props.match.params.courseId);
    return (
      <Query query={COURSE_LIST_QUERY} variables={{ ids: [courseId] }}>
        {({ loading, error, data }) => {
          if (error) return <div>{error.message}</div>;
          if (loading) return <div>loading...</div>;
          if (!data) {
            // @ts-ignore
            return <Empty />;
          }
          const courses = (data && data.courses) || [];
          const [course] = courses;
          const { lessons } = course;
          return (
            <>
              <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
                <Breadcrumb.Item>
                  <Link to={`/Home`}>首页</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  <Link to={`/course/list`}>课程列表</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>{course.name}</Breadcrumb.Item>
              </Breadcrumb>
              <Panel>
                <Card>
                  <h3>课程名： {course.name}</h3>
                  <div>{this.batchImportSpeeches()}</div>
                </Card>
                <Table<Course> dataSource={lessons} pagination={false} rowKey={lesson => `${lesson.id}`}>
                  <Table.Column title="ID" dataIndex="id" key="id" />
                  <Table.Column title="课时" dataIndex="name" key="name" />
                  <Table.Column
                    title="操作"
                    key="action"
                    render={row => (
                      <>
                        <SpeechAdditionForm courseId={courseId} lessonId={row.id} />
                        <Link to={`/course/${courseId}/lesson/${row.id}/speechDetail`} style={{ marginLeft: 5 }}>
                          详情
                        </Link>
                      </>
                    )}
                  />
                </Table>
              </Panel>
            </>
          );
        }}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/course/LessonList.tsx